import { useCallback } from 'react';

import type { ShareChannel } from 'src/app/pages/psf/promoteOrShare/shared/types';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import { useGenPetitionUrl } from './genUrl';
import { useGetPetitionShareUrlSuffix } from './pathSuffix';
import { useFacebookShareMetadata } from './useFacebookShareMetadata';

const MEDIUM_MAPPING: Partial<Record<ShareChannel, string>> = {
	facebookMessenger: 'facebook',
	copy: 'copylink',
};

export function useGetShareUrl(): ShareActionsOptions<ShareChannel>['getUrl'] {
	const genUrl = useGenPetitionUrl();
	const getDefaultPathSuffix = useGetPetitionShareUrlSuffix();
	const fbExpUtmContent = useFacebookShareMetadata();

	return useCallback(
		(channel) => {
			const medium = MEDIUM_MAPPING[channel] || channel;
			const pathSuffix = getDefaultPathSuffix(channel);

			if (fbExpUtmContent && channel === 'facebook') {
				return genUrl({
					medium,
					pathSuffix,
					additionalParams: fbExpUtmContent,
				});
			}

			return genUrl({ medium, pathSuffix });
		},
		[fbExpUtmContent, genUrl, getDefaultPathSuffix],
	);
}
